import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1335 7.34006C9.78367 6.90949 9.59529 6.38473 9.59529 5.83306V4.78355C9.59529 3.51874 8.70724 2.46923 7.52317 2.21358V1.71573C7.52317 1.40626 7.26752 1.1506 6.95805 1.1506C6.64857 1.1506 6.39292 1.40626 6.39292 1.71573V2.21358C5.20885 2.46923 4.3208 3.51874 4.3208 4.78355V5.83306C4.3208 6.38473 4.13243 6.90949 3.78259 7.34006L3.33856 7.90519C3.01563 8.30885 3.29819 8.90088 3.8095 8.90088H10.1335C10.6448 8.90088 10.9274 8.30885 10.6044 7.90519L10.1335 7.34006Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.46012 1.55422C9.2852 1.74259 9.2852 2.03861 9.47358 2.21353C10.106 2.81902 10.4827 3.6398 10.5365 4.50094C10.55 4.74313 10.7653 4.93151 11.0075 4.93151C11.0209 4.93151 11.0344 4.93151 11.0344 4.93151C11.29 4.91805 11.4919 4.68931 11.465 4.43366C11.3842 3.34378 10.9133 2.30772 10.1194 1.54076C9.93106 1.36584 9.63504 1.3793 9.46012 1.55422Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.41884 4.51447C3.48612 3.65333 3.86287 2.83256 4.48181 2.22707C4.67019 2.05215 4.67019 1.74267 4.49527 1.56775C4.32035 1.37938 4.01088 1.37938 3.83596 1.5543C3.04209 2.32125 2.57116 3.35731 2.49042 4.4472C2.47697 4.70285 2.66534 4.93159 2.92099 4.94504C2.93445 4.94504 2.94791 4.94504 2.94791 4.94504C3.1901 4.9585 3.39193 4.75667 3.41884 4.51447Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.24375 0.814183C3.43212 0.639264 3.44558 0.343246 3.27066 0.154872C3.09574 -0.0335032 2.79972 -0.0469585 2.61135 0.127961C1.31963 1.32549 0.57959 3.02086 0.57959 4.78351V4.90461C0.57959 5.16026 0.794875 5.37554 1.05053 5.37554C1.30618 5.37554 1.52146 5.16026 1.52146 4.90461V4.78351C1.52146 3.26306 2.12695 1.85024 3.24375 0.814183Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3444 0.128006C11.1561 -0.0469133 10.8601 -0.0469133 10.6851 0.154917C10.5102 0.343292 10.5102 0.639309 10.712 0.814228C11.8288 1.85029 12.4343 3.2631 12.4343 4.78355V4.90465C12.4343 5.1603 12.6496 5.37559 12.9053 5.37559C13.1609 5.37559 13.3762 5.1603 13.3762 4.90465V4.78355C13.3627 3.0209 12.6227 1.32553 11.3444 0.128006Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.97151 11C7.71155 11 8.31704 10.3945 8.31704 9.65448H5.62598C5.62598 10.3945 6.23147 11 6.97151 11Z",
			fill: "#454545"
		})
	]
});
export default SvgBell;
